module.exports = __webpack_public_path__ + "e6da6b56b2ae85ae32ef92e7fd06fb64.jpg";